import SpecialtyType from './lib/masters/SpecialtyType'
import FeatureType from './lib/masters/FeatureType'

export enum ErrorMessage {
  UserNotFound = 'UserNotFound',
  UserAlreadyExsists = 'UserAlreadyExsists'
}

export enum Page {
  Home = 'Home',
  Terms = 'Terms',
  Signin = 'Signin',
  Signup = 'Signup',
  Mypage = 'Mypage',
  Users = 'Users',
  AdminUsers = 'AdminUsers'
}

export enum StorageFileName {
  Profile = 'profile.png',
  Profile2 = 'profile2.png'
}

export type NavigationMenu = {
  action: () => void
  text: string
  icon?: string
}

export type UserSearchFormParams = {
  word: string
  specialtyTypes: SpecialtyType[]
  featureTypes: FeatureType[]
}

export const Url = {
  LineTransition: 'https://lin.ee/pZvppT6'
}
